import {InjectionToken, NgModule} from '@angular/core';
import {ExtraOptions, RouterModule, Routes, ActivatedRouteSnapshot, ROUTES} from '@angular/router';
import {PageErrorComponent} from './modules/error/pageError/page-error.component';
import {RedirectComponent} from './components/redirect/redirect.component';
import {ClientRedirectComponent} from './components/client-redirect/client-redirect.component';
import {SignatureRedirectComponent} from 'src/app/components/signature-redirect/signature-redirect.component';
import {EndSessionComponent} from './components/end-session/end-session.component';

const externalUrlProvider = new InjectionToken('externalUrlRedirectResolver');
type PathMatch = 'full' | 'prefix' | undefined;

const routes: Routes = [
    {path: '', pathMatch: 'full' as PathMatch, component: PageErrorComponent},
    {path: 'client/:idClient', component: ClientRedirectComponent, data: {title: ''}},
    {path: 'signature_session/:transactionId', component: SignatureRedirectComponent, data: {title: 'Finalisation'}},
    {path: 'fin_de_session', component: EndSessionComponent, data: {title: 'Fin de session'}},
    {path: 'externalRedirect', resolve: {url: externalUrlProvider}, component: RedirectComponent},
    {path: 'erreur', loadChildren: () => import('./modules/error/error.module').then(m => m.ErrorModule)}
];

const routerOptions: ExtraOptions = {
    onSameUrlNavigation: 'reload',
    // preloadingStrategy: PreloadAllModules,
    // enableTracing: true,
    useHash: false,
    anchorScrolling: 'enabled'
};

@NgModule({
    imports: [RouterModule.forRoot(routes, routerOptions)],
    exports: [RouterModule],
    providers: [
        {
            provide: externalUrlProvider,
            useValue: (route: ActivatedRouteSnapshot) => {
                const externalUrl = route.paramMap.get('externalUrl');
                console.log('externalUrl:', externalUrl);
                window.open(externalUrl, '_self');
            },
        }
    ]
})
export class AppRoutingModule {
}
